import { Button, Form, Input, Select, Space, message, Spin } from 'antd';
import { useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Link } from 'react-router-dom';

const { Option } = Select;

interface SectorData {
    id: number;
    descripcion: string;
    alta: number;
  }

interface EquipoData {
    id: number;
    descripcion: string;
    id_sector: number;
    id_empresa: number;
    id_sucursal: number;
    alta: number;
  }
  

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};

const tailLayout = {
  wrapperCol: { offset: 8, span: 16 },
};

const CrearEquipos: React.FC = () => {
  const [form] = Form.useForm();
  const [buttonLoading, setButtonLoading] = useState(false);

  const {user} = useAuth0();
  const empresa = user?.id_empresa;
  const sucursal = user?.id_sucursal;
    /*const [loading, setLoading] =  useState(false);*/
  const { getAccessTokenSilently , isLoading } = useAuth0();
  const [sectores, setSectores] = useState<SectorData[]>([]);
  const [loadingSectores, setLoadingSectores] = useState(false);
  const [equipos, setEquipos] = useState<EquipoData[]>([]);
  const [loadingEquipos, setLoadingEquipos] = useState(false);
  
  // Función para cargar las marcas
  const fetchSectores = async () => {
    console.log('xfethSectores',empresa,sucursal)
    setLoadingSectores(true);
    try {
      const accessToken = await getAccessTokenSilently();
      const response = await fetch(`${process.env.REACT_APP_INSUMOS_URL}/listar_sectores/${empresa}/${sucursal}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accessToken}`,
        },
      });

      if (!response.ok) {
        throw new Error('Error al cargar los sectores');
      }

      const data = await response.json();
      // Filtrar solo los registros con clasificacion = 3 (Marca)
      const soloSectores = data.filter((item: SectorData) => item.alta === 1);
      setSectores(soloSectores);
    } catch (error) {
      console.error('Error:', error);
      message.error('Error al cargar los sectores');
    } finally {
      setLoadingSectores(false);
      /*setLoadingGrupos(false);
      setLoadingSubGrupos(false);*/
    }
  };

  const fetchEquipos = async () => {
    setLoadingEquipos(true);
    try {
      const accessToken = await getAccessTokenSilently();
      const response = await fetch(`${process.env.REACT_APP_INSUMOS_URL}/editar_equipos`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accessToken}`,
        },
      });

      if (!response.ok) {
        throw new Error('Error al cargar los sectores');
      }

      const data = await response.json();
      // Filtrar solo los registros con clasificacion = 3 (Marca)
      const soloEquipos = data.filter((item: EquipoData) => item.alta === 1);
      setEquipos(soloEquipos);
    } catch (error) {
      console.error('Error:', error);
      message.error('Error al cargar los equipos');
    } finally {
      setLoadingSectores(false);
      /*setLoadingGrupos(false);
      setLoadingSubGrupos(false);*/
    }
  };


  // Cargar las marcas cuando el componente se monta
  useEffect(() => {
    if(isLoading){
      return;
    }
    fetchSectores();
/*    fetchEquipos();*/
  }, [isLoading,empresa,sucursal]);

  const handleAdd = () => {
    setButtonLoading(true);
    form.validateFields().then(async (values) => {
      try {
        const accessToken = await getAccessTokenSilently();
        const response = await fetch(`${process.env.REACT_APP_INSUMOS_URL}/crear_equipos`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`,
          },
          body: JSON.stringify({
            ...values,
            id_empresa: empresa,
            id_sucursal: sucursal
          /*  tipo: values.tipo*/
          }),
        });
        if (!response.ok) {
          
          throw new Error('Network response was not ok');
        }
        message.success('Equipo añadido correctamente');
        form.resetFields();
      } catch (error) {
        console.error('Error adding equipo:', error);
        message.error(`Error al añadir el equipo:${error}`);
      } finally {
        setButtonLoading(false);
      }
    });
  };



  const onFinish = (values: any) => {
    console.log(values);
  };

  return (
    <Spin spinning={loadingSectores || buttonLoading} tip="Cargando...">
      <Form
        {...layout}
        form={form}
        name="control-hooks"
        onFinish={onFinish}
        style={{ maxWidth: 600}}
      >
        <Form.Item 
        name="sector" 
        label="Sector" 
        rules={[{ required: true, message: 'Por favor seleccione un sector' }]}
      >
        <Select
          placeholder="Seleccione un sector"
          loading={loadingSectores}
          showSearch
          optionFilterProp="children"
          filterOption={(input, option) =>
            (option?.children as unknown as string)
              .toLowerCase()
              .includes(input.toLowerCase())
          }
        >
          {sectores.map(sector => (
            <Select.Option key={sector.id} value={sector.id}>
              {sector.descripcion}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item name="descripcion" label="Descripcion" rules={[{ required: true }]}>
        <Input maxLength={40} showCount />
      </Form.Item>
           <Form.Item {...tailLayout}>
        <Space>
          <Button 
          type="primary" 
          htmlType="submit"
          onClick={handleAdd}
          loading={buttonLoading}
          disabled={buttonLoading}
          >
            {buttonLoading ? 'Guardando...' : 'Guardar'}
          </Button>
          <Button type="default"><Link to= '/listar_equipos'>
            Listar
          </Link>
          </Button>
        </Space>
      </Form.Item>
    </Form>
    </Spin>
  );
};

export default CrearEquipos;